import { BehaviorSubject, Observable } from 'rxjs';
import { Language } from '../Models/Language/Language';
import { LanguageHelper } from '../Helpers/LanguageHelper';
import { authService } from '../App';

export class LanguageService {
  public FetchingReadySubject: BehaviorSubject<boolean>;
  public FetchingReady!: boolean;

  public languages!: Language[];
  public languagesTranslations!: Language[];

  public currentLanguage!: Language;

  constructor() {
    this.FetchingReadySubject = new BehaviorSubject<boolean>(false);
  }

  private async FetchItems(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      this.FetchingReady = true;
      this.languages = await LanguageHelper.GetAvailableLanguages();
      this.languagesTranslations = await LanguageHelper.GetLanguages();
      this.FetchingReadySubject.next(true);
    }
  }

  public GetFetchStatus(): Observable<boolean> {
    this.FetchItems();
    return this.FetchingReadySubject;
  }

  public async GetLanguages(forceUpdate: boolean = false) {
    if (!this.FetchingReady || forceUpdate) {
      await this.FetchItems();
    }

    return this.languages;
  }

  public GetLanguage(item: string) {
    var index = this.languagesTranslations.findIndex(
      (x) => x.languageKey === item,
    );
    return this.languagesTranslations[index];
  }

  public SetCurrentLanguage(item: Language) {
    this.currentLanguage = item;
  }

  public GetCurrentLanguage() {
    return this.currentLanguage;
  }

  public ReplaceLanguages(items: Language[]) {
    this.languages = items;
    LanguageHelper.ReplaceLanguages(items);
    return this.languages;
  }

  // update overview
  public UpdateLanguage(item: Language) {
    var index = this.languages.findIndex((x) => x.id === item.id);
    this.languages[index] = item;
    LanguageHelper.UpdateLanguage(item, authService.GetToken());
  }

  // add overview
  public async AddLanguage(newItem: Language) {
    var createdItem = await LanguageHelper.AddLanguage(
      newItem,
      authService.GetToken(),
    );
    this.languages.push(createdItem);
  }

  // remove overview
  public DeleteLanguage(item: Language) {
    var index = this.languages.findIndex((x) => x.id === item.id);
    this.languages.splice(index, 1);
    LanguageHelper.DeleteLanguage(item, authService.GetToken());
  }

  public async ExportLanguages() {
    let token = authService.GetToken();
    await LanguageHelper.ExportLanguages(await this.GetLanguages(), token);
  }
}
